import { IUserSettings, UserSettingsContext } from '@/contexts/user-settings/helpers';
import { useContext } from 'react';

const useUserSettings = () => useContext<IUserSettings>(UserSettingsContext);

export default useUserSettings;
